import { Field } from 'redux-form';
import { RenderCheckbox, RenderLabeledInput } from 'components/Shared/Form/inputs';
import styles from './styles.scss';
import { useSelector } from 'react-redux';
import { selectNeedsCertificateId } from './selector';
import { NO_ELEMENT, rm } from 'utils';
import cn from 'classnames';
import { ToolTip } from 'components/Shared/ToolTip';
import * as rules from 'views/CheckoutPage/validation';

interface OwnProps {
  className?: string;
}

export const CertificateForm = ({ className }: OwnProps) => {
  const needsCertificateId = useSelector(selectNeedsCertificateId);

  if (!needsCertificateId) {
    return NO_ELEMENT;
  }

  return (
    <>
      <div className={cn(className, styles.block)}>
        <strong>{rm('checkout_certificate_header')}</strong>{' '}
        <ToolTip text={rm('checkout_certificate_what_is')} />
        <strong>
          <p>{rm('checkout_certificate_disclaimer')}</p>
        </strong>
        <Field
          name="confirmCertifiedInstallation"
          checkboxClassName={styles.confirmInput}
          props={{ customLabel: rm('checkout_certificate_confirm') }}
          component={RenderCheckbox}
          validate={rules.confirmCertificate}
        />
        <p>{rm('checkout_certificate_help')}</p>
        <div className={styles.fields}>
          <Field
            name="certifiedInstallerName"
            type="text"
            className={styles.name}
            props={{ customLabel: rm('checkout_certificate_installer_name') }}
            component={RenderLabeledInput}
          />
          <Field
            name="certifiedInstallerNumber"
            type="text"
            className={styles.number}
            props={{ customLabel: rm('checkout_certificate_installer_number') }}
            component={RenderLabeledInput}
          />
        </div>
        <p
          className={styles.help}
          dangerouslySetInnerHTML={{ __html: rm('checkout_certificate_find_text') }}
        />
      </div>
    </>
  );
};
